// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"252":"00b3c8a1","2888":"f6278165","4714":"ee19a799","4744":"00b3c8a1","8497":"f92a3973"}[chunkId] + ".chunk.css";
};